"use client"

import type React from "react"

interface GoldDisplayProps {
  gold: number
  interestAnimation?: number | null
  sellAnimation?: number | null
  interestBonusPercent?: number // Bonus from Dwarven Treasury (e.g., 0.005 = +0.5%)
  className?: string
  style?: React.CSSProperties
}

export const GoldDisplay = ({ gold, interestAnimation, sellAnimation, interestBonusPercent, className, style }: GoldDisplayProps) => {
  // Format bonus percentage for display
  const bonusDisplay = interestBonusPercent && interestBonusPercent > 0
    ? `+${(interestBonusPercent * 100).toFixed(1)}%`
    : null

  return (
    <div
      id="money-display"
      className={
        className || "bg-black bg-opacity-60 text-white pl-4 pr-2 py-1 rounded-lg flex items-center gap-1.5 relative"
      }
      style={style}
    >
      <div className="absolute -left-1.5 top-1/2 -translate-y-1/2">
        <img
          src="/images/icon-coins.png"
          alt="Coins"
          width={28}
          height={28}
          className="drop-shadow-lg"
          style={{ imageRendering: "pixelated" }}
        />
      </div>
      <span className="font-bold text-white text-sm ml-2 pl-1">{gold}</span>

      {/* Interest bonus indicator from Dwarven Treasury */}
      {bonusDisplay && (
        <span
          className="ml-1 text-amber-400 font-bold text-xs"
          style={{
            textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0 0 4px #000",
          }}
          title="Dwarven Treasury interest bonus"
        >
          {bonusDisplay}
        </span>
      )}

      {interestAnimation !== null && interestAnimation !== undefined && interestAnimation > 0 && (
        <div
          id="interest-animation"
          className="absolute left-full ml-2 flex items-center gap-1 text-green-400 font-bold text-sm animate-bounce"
          style={{
            textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0 0 4px #000",
          }}
        >
          <span>+${interestAnimation}</span>
        </div>
      )}

      {sellAnimation !== null && sellAnimation !== undefined && sellAnimation > 0 && (
        <div
          id="sell-animation"
          className="absolute left-full ml-2 flex items-center gap-1 text-yellow-400 font-bold text-sm animate-bounce"
          style={{
            textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0 0 4px #000",
          }}
        >
          <span>+${sellAnimation}</span>
        </div>
      )}
    </div>
  )
}
